import React from 'react';
import { Link } from 'react-router-dom';

const TOPMATE_URL = 'https://topmate.io/acharya_ji_ajay_l_agrawal/2021138?utm_source=public_profile&utm_campaign=acharya_ji_ajay_l_agrawal';
const LOGO_URL = 'https://media-manager-c.questera.ai/greta-media/950656ff8acc2b4c64dfb2a5e756971f95d9a65d0f8c5ef3b6e107600fb8dee58cb5b46485e4f90e0b9e2ba9c3364607/images/aW1hZ2UvcG5n/eb4bceeb288390e78457973c0c9f34e6.png';

export default function Footer() {
  return (
    <footer className="bg-brand-dark text-stone-400 py-16 px-6 md:px-12 text-base font-medium">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-16">
          <div className="max-w-sm">
            <div className="mb-6">
              <img src={LOGO_URL} alt="Acharya Ajay L Agarwal" className="h-16 w-auto opacity-90" />
            </div>
            <p className="text-sm text-stone-400 leading-relaxed font-medium">
              Vedic Astrology, Vastu Shastra, Muhurta Science, Business Advisory. Serving NRIs and business families globally for 30+ years.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-16 text-base">
            <div>
              <p className="text-brand-gold text-sm uppercase tracking-widest font-bold mb-6">Services</p>
              <div className="space-y-4">
                <a href="#consult" className="block hover:text-white transition-colors">Vedic Astrology Reading</a>
                <a href="#consult" className="block hover:text-white transition-colors">Vastu Consultation</a>
                <a href="#reflect" className="block hover:text-white transition-colors">Decision Reflection</a>
              </div>
            </div>
            <div>
              <p className="text-brand-gold text-sm uppercase tracking-widest font-bold mb-6">Legal</p>
              <div className="space-y-4">
                <a href={TOPMATE_URL} target="_blank" rel="noopener noreferrer" className="block hover:text-white transition-colors">
                  Book Consultation
                </a>
                <Link to="/privacy" className="block hover:text-white transition-colors">Privacy Policy</Link>
                <Link to="/terms" className="block hover:text-white transition-colors">Terms of Service</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-stone-800 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm text-stone-500">
            © {new Date().getFullYear()} Acharyaji Ajay L Agarwal. All rights reserved.
          </p>
          <p className="text-xs text-stone-500 max-w-xl text-center md:text-right leading-relaxed font-medium">
            Disclaimer: Vedic Astrology and Vastu Shastra offer strategic guidance based on ancient sciences. They are not substitutes for professional financial, medical, or legal advice. All decisions remain the sole responsibility of the client.
          </p>
        </div>
      </div>
    </footer>
  );
}